import React from 'react';
import type { SegmentedProps as AntSegmentedProps } from 'antd-v5';
import { Segmented as AntSegmented } from 'antd-v5';

export type SegmentedValue = string | number;

export interface SegmentedOption {
  label: React.ReactNode;
  value: SegmentedValue;
  disabled?: boolean;
}

export interface SegmentedProps {
  value?: SegmentedValue;
  defaultValue?: SegmentedValue;
  options: (SegmentedOption | SegmentedValue)[];
  onChange?: (value: SegmentedValue) => void;
  disabled?: boolean;
  size?: AntSegmentedProps['size'];
  block?: boolean;
  className?: string;
  'data-cy'?: string;
}

export const Segmented = ({
  value,
  defaultValue,
  options,
  onChange,
  disabled,
  size,
  block,
  className,
  'data-cy': dataCy,
}: SegmentedProps) => {
  return (
    <AntSegmented
      value={value}
      defaultValue={defaultValue}
      options={options}
      onChange={onChange as AntSegmentedProps['onChange']}
      disabled={disabled}
      size={size}
      block={block}
      className={className}
      data-cy={dataCy}
    />
  );
};
